export default "__VITE_ASSET__F_EPNByI__"